import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

export default class extends Controller {
  static targets = ['pocItemDetailContainer'];

  initialize() {
    this.initialSelect2();
    this.initialDataTables();
  }

  pocChange(e) {
    const selectPocIds = e.target.selectedOptions;
    const polId = $('#pol_id').val();
    const pocIds = Array.from(selectPocIds, (option) => option.value);

    const url = `/pols/${polId}/pols_item_details/pocs_categories?poc_ids=${pocIds}`;
    this.hiddenPocItemDetail();

    get(url, {
      responseKind: 'turbo-stream',
    }).finally(() => {
    });
  }

  search() {
    const polId = $('#pol_id').val();
    const query = new URLSearchParams({ poc_ids: $('#poc').val() });

    $('#category')
      .val()
      .forEach((category) => query.append('categories[]', category));

    const url = `/pols/${polId}/pols_item_details/pocs_item_details?${query}`;
    this.openSpanner();
    get(url, {
      responseKind: 'turbo-stream',
    })
      .then(() => {
        this.pocItemDetailContainerTarget.classList.remove('d-none');
      })
      .catch(() => {
        this.hiddenPocItemDetail();
      })
      .finally(() => {
        this.disableSpanner();
      });
  }

  clearSearch() {
    $('#poc').val(null).trigger('change.select2');
    $('#category').empty().trigger('change.select2');
    this.hiddenPocItemDetail();
  }

  openSpanner(e) {
    $('.overlay').addClass('show');
    $('.spanner').addClass('show');
  }

  disableSpanner(e) {
    $('.spanner').removeClass('show');
    $('.overlay').removeClass('show');
  }

  checkBoxSeleced(e) {
    $(`#item-detail-qty-${e.target.value}`).prop('checked', e.target.checked);
    if (e.target.checked) {
      $(`input[type=number][id='${e.target.value}'`)[0].disabled = false;
    } else {
      $(`input[type=number][id='${e.target.value}'`)[0].disabled = true;
    }
  }

  toggleSelectAllItemDetail(e) {
    $(
      "input[type=checkbox][name='pols_item_detail[][item_detail_id]'], input[type=checkbox][name='pols_item_detail[][qty]']",
    ).prop('checked', e.target.checked);

    $('input[type=number][name="item-detail"').each((k, v) => {
      if (e.target.checked) {
        v.disabled = false;
      } else {
        v.disabled = true;
      }
    });
  }

  hiddenPocItemDetail() {
    this.pocItemDetailContainerTarget.classList.add('d-none');
  }

  onSelect2Change(e) {
    const select = e.currentTarget;
    select.dispatchEvent(new Event('change'));
  }

  initialSelect2() {
    $('select#poc, select#category').each((_, select) => {
      if ($(select).data('select2')) {
        return;
      }

      $(select)
        .select2()
        .on('select2:select select2:unselect', this.onSelect2Change);

      document.addEventListener('turbo:before-cache', () => {
        if (!$(select).data('select2')) {
          return;
        }

        $(select).select2('destroy');
      });
    });
  }

  initialDataTables() {
    const table = 'table#pocItemDetailTable';

    if (!$(table).length) {
      return;
    }

    if (!$.fn.DataTable.isDataTable(table)) {
      $(table).DataTable({
        paging: false,
        columnDefs: [{ orderable: false, targets: 0 }],
        order: [],
      });
    }
  }

  setQTY(e) {
    const needQuantity = parseInt(e.target.value);
    const quantity = parseInt($(`input[type=hidden][name="needQTY-${e.target.id}"`).val());
    if (needQuantity <= quantity) {
      $(`#item-detail-qty-${e.target.id}`).val(needQuantity);
    }
  }
}
